import { graphql } from '@/gql'

export const JobFragment = graphql(/* GraphQL */ `
  fragment Job on Job {
    id
    company {
      id
      name
    }
    name
    contactName
    contactEmail
    contactPhone
    sourceJob {
      id
      name
      currency
      company {
        id
        name
      }
    }
    viewerCandidateSubmissionLimit
    viewerCanEdit
    viewerCanShare
    viewerCanCreateJobCandidate
    viewerCanCreateHire
    published
    isForRecruiters
    isForMarketplace
    isBrief
    available
    recruiterShares: shares(isActive: true, accountTypes: [RECRUITER, COMPANY]) {
      paginatorInfo {
        total
      }
      data {
        id
        account {
          ... on Recruiter {
            id
            name
          }
          ... on Company {
            id
            name
          }
        }
      }
    }
    workerShares: shares(isActive: true, accountTypes: [WORKER]) {
      paginatorInfo {
        total
      }
    }
  }
`)

export const JobCandidateFragment = graphql(/* GraphQL */ `
  fragment JobCandidate on JobCandidate {
    id
    worker {
      id
      name
      jobTitle
      avatar
      profile {
        url
      }
      address {
        country {
          isoCode
          name
        }
      }
      hiresWithAttribution {
        recruiter {
          name
        }
        fees {
          ...FeeFragment
        }
        recruiterManagesWorkers
        recruiterOwnershipStartDate
        recruiterOwnershipDays
        recruiterOwnershipDaysLeft
      }
    }
    bid {
      id
      rate
      rateType
      currency
      brief
      links
      workerType
      files {
        id
        name
        url
        tags {
          name
        }
      }
      fees {
        id
        feeType
        application
        basis
        rate
      }
      conversation {
        id
        url
      }
      message {
        id
        url
      }
      worker {
        id
        name
      }
      supplier {
        id
        name
      }
    }
    jobShare {
      id
      isActive
    }
    hire {
      id
      activeStatus
    }
    job {
      conversations(first: $first) {
        data {
          id
          url
          participants(first: $first, accountTypes: [WORKER]) {
            data {
              id
              account {
                id
              }
            }
          }
        }
      }
    }
    jobShare {
      id
      isActive
    }
    sourcingChannel
    submissionType
    owner {
      name
    }
    sourceAgencyName
    contactName
    contactEmail
    contactPhone
    step
    status
    createdAt
    updatedAt
    statusReason
    statusComment
    isPreferred
    presentedToClient
    sourceCandidate {
      id
      bid {
        id
        rate
        rateType
        currency
        workerType
        fees {
          id
          feeType
          application
          basis
          rate
        }
      }
    }
    presentedCandidate {
      id
      status
    }
    stageHistory {
      stage
      changedByName
      createdAt
    }
    viewerCanWithdrawForwardedCandidate
    viewerCanWithdraw
    viewerCanUpdateStatus
    viewerCanUpdatePreferred
    viewerCanInviteToOnboard
  }
`)

export const JobFormDataFragment = graphql(/* GraphQL */ `
  fragment JobFormData on Job {
    id
    company {
      id
      currency
      settings {
        multiCurrencyContractsDisabled
      }
      address {
        address
        postCode
        city
        state
        country {
          isoCode
        }
      }
    }
    name
    description
    contactName
    contactEmail
    contactPhone
    startDate
    endDate
    startDateTimeframe
    endDateTimeframe
    updatedAt
    locationPreference
    address
    location {
      address
      postCode
      city
      state
      country {
        isoCode
      }
    }
    rateType
    rate
    minimumRate
    maximumRate
    association
    visibility
    skills {
      name
    }
    industries {
      id
      name
    }
    attachments {
      id
      name
      storageName: name
    }
    removed
    available
    published
    approved
    paused
    completed
    isExtensionAvailable
    expectedExperienceLevel
    viewerCanDelete
    isForMarketplace
    evaluationPeriod
    sourcingEndDateLocal
    sourcingDeadlineChoice
    internalBudget
    project {
      id
    }
    owners {
      id
      avatar
      name
    }
    languages {
      ...JobLanguage
    }
    customFieldValues {
      ...FieldableFormCustomFieldValue
    }
    requiredWorkers
    canBePublished
    sourceJob {
      id
      name
      rate
      minimumRate
      maximumRate
      rateType
      currency
      startDate
      endDate
      company {
        id
        name
        avatar
      }
    }
    supplierJob {
      id
    }
  }
`)

export const JobLanguageFragment = graphql(/* GraphQL */ `
  fragment JobLanguage on Language {
    name
    experience
  }
`)

export const JobFormShareWorkerFragment = graphql(/* GraphQL */ `
  fragment JobFormShareWorker on JobShare {
    id
    account {
      ...JobFormShareableWorker
    }
  }
`)

export const JobFormShareRecruiterFragment = graphql(/* GraphQL */ `
  fragment JobFormShareRecruiter on JobShare {
    id
    account {
      ...JobFormShareableRecruiter
    }
  }
`)

export const JobFormShareableWorkerFragment = graphql(/* GraphQL */ `
  fragment JobFormShareableWorker on Worker {
    id
    name
    avatar
    jobTitle
  }
`)

export const JobFormShareableRecruiterFragment = graphql(/* GraphQL */ `
  fragment JobFormShareableRecruiter on Recruiter {
    id
    name
    avatar
  }
`)
